import React from 'react'
import { useHistory } from 'react-router-dom'

import Box from 'components_new/atoms/Box'
import List from 'components_new/atoms/List'
import Skeleton from 'components_new/atoms/Skeleton'
import TextField from 'components_new/atoms/TextField'
import SiderBase from 'components/common/Sider'

import ToggleButton from 'components_new/molecules/ToggleButton'

import { InfoMessage } from 'components/containers/Applications/DataProducts/ManageDatasetModal/Operations/ManageOperation/conf'

import PageLayout from 'components_new/templates/PageLayout'

const Sider = SiderBase as unknown as React.ComponentType<{ options: any[] }>

// Height of the placeholders passed as emptyContent.
export const PLACEHOLDER_HEIGHT = 512

interface OntologyLayoutProps {
  currentType: 'custom' | 'standard'
  isFetched: boolean
  search: string
  onSearchChange: (value: string) => void
  filterType: string
  onFilterTypeChange: (value: string) => void
  topContent?: React.ReactNode
  filterActions?: React.ReactNode
  // Placeholder rendered instead of the filter bar and the table list.
  emptyContent?: React.ReactNode
  children: React.ReactNode
}

const OntologyLayout = ({
  currentType,
  isFetched,
  search,
  onSearchChange,
  filterType,
  onFilterTypeChange,
  topContent,
  filterActions,
  emptyContent,
  children
}: OntologyLayoutProps) => {
  const history = useHistory()

  return (
    <PageLayout
      content={{ disablePadding: true, fullWidth: true }}
      topbar={{
        breadcrumbs: [{ title: 'Admin' }, { title: 'Informationsmodell' }]
      }}
      variant={'feed'}
    >
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {topContent}

          {emptyContent ? (
            <Box sx={{ width: '100%', p: 2 }}>{emptyContent}</Box>
          ) : (
            <>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  p: 2,
                  gap: 4
                }}
              >
                <TextField
                  value={search}
                  onChange={(e: any) => onSearchChange(e.target.value)}
                  placeholder={'Sök..'}
                  size={'small'}
                  sx={{ p: 0, m: 0 }}
                />
                <ToggleButton
                  color={'primary'}
                  exclusive={true}
                  fullWidth={true}
                  items={[
                    { title: 'Alla', iconName: 'List', value: 'all' },
                    {
                      title: 'Modellerade',
                      iconName: 'CheckBoxOutlined',
                      value: 'modeled'
                    },
                    {
                      title: 'Ej modellerade',
                      iconName: 'CheckBoxOutlineBlankOutlined',
                      value: 'unmodeled'
                    }
                  ]}
                  size={'small'}
                  value={filterType}
                  onChange={(_event: any, value: string) => {
                    if (!value) return
                    onFilterTypeChange(value)
                  }}
                  sx={{ p: 0, m: 0 }}
                />
                {filterActions}
              </Box>

              {isFetched ? (
                <List dense={true}>{children}</List>
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0.5,
                    minHeight: '100vh',
                    px: 2,
                    pt: 1
                  }}
                >
                  {Array.from({
                    length: Math.ceil(window.innerHeight / 30)
                  }).map((_, i) => (
                    <Skeleton
                      key={i}
                      variant="rounded"
                      height={30}
                      width={'100%'}
                    />
                  ))}
                </Box>
              )}
            </>
          )}
        </Box>

        <Sider
          options={[
            {
              icon: 'AccountTreeOutlined',
              header: 'Ändra informationsmodell',
              index: 0,
              content: (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <InfoMessage
                    infoText={
                      'Välj vilken informationsmodell du vill få en överblick av. Om du inte har en standardmodell aktiverad, så kan du göra det under "Standard"-fliken.'
                    }
                  />
                  <ToggleButton
                    items={[
                      { title: 'Anpassad', value: 'custom' },
                      { title: 'Standard', value: 'standard' }
                    ]}
                    onChange={(_event: any, value: string) => {
                      history.push(`/data-platform/ontology/${value}`)
                    }}
                    size="small"
                    value={currentType}
                  />
                </Box>
              )
            }
          ]}
        />
      </Box>
    </PageLayout>
  )
}

export default OntologyLayout
